import { Base, importWhenVisible } from '@studiometa/js-toolkit';
import { Action, Tabs, LargeText, ScrollAnimationParent } from '@studiometa/ui';
import ZoomedGallery from './ZoomedGallery.js';
import Slider from './Slider/index.js';
import ProductLastViewed from './ProductLastViewed.js';
import ProductRecommendations from './ProductRecommendations.js';
import HeroTabs from './HeroTabs.js';

/**
 * Sections component
 */
export default class Sections extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Sections',
    components: {
      HeroTabs,
      Action,
      ScrollAnimationParent,
      Tabs,
      LargeText,
      Slider,
      ZoomedGallery,
      Instagram: (app) => importWhenVisible(() => import('./Instagram/index.js'), 'Instagram', app),
      ProductLastViewed,
      ProductRecommendations,
      VideoLinks: (app) => importWhenVisible(() => import('./VideoLinks.js'), 'VideoLinks', app),
      Stories: (app) => importWhenVisible(() => import('./Stories/index.js'), 'Stories', app),
      CollectionLinks: (app) =>
        importWhenVisible(() => import('./CollectionLinks.js'), 'CollectionLinks', app),
      Video: (app) => importWhenVisible(() => import('./Video.js'), 'Video', app),
      Audio: (app) => importWhenVisible(() => import('./Audio.js'), 'Audio', app),
      Explore: (app) => importWhenVisible(() => import('./Explore.js'), 'Explore', app),
      Accordion: (app) => importWhenVisible(() => import('./Accordion/index.js'), 'Accordion', app),
      BookingForm: (app) => importWhenVisible(() => import('./BookingForm.js'), 'BookingForm', app),
      FooterNewsletter: (app) =>
        importWhenVisible(() => import('./FooterNewsletter.js'), 'FooterNewsletter', app),
      StoreLocator: (app) =>
        importWhenVisible(() => import('./StoreLocator/index.js'), 'StoreLocator', app),
    },
  };
}
